<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="450"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        :dark="!disabled"
        :disabled="disabled"
        v-on="on"
      >
        {{ $t('message.set_to_draft_button') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        {{ $t('message.confirm_set_to_draft_title') }}
      </v-card-title>
      <v-card-text>
        {{ $t('message.confirm_set_to_draft_text') }}
        <v-textarea
          v-model="notes"
          box
          :label="$t('message.adminNotes')"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          flat
          @click="show = false"
        >
          {{ $t('message.set_to_draft_dialog_no_button') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="$emit('confirm', notes)"
        >
          {{ $t('message.set_to_draft_dialog_yes_button') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    disabled: Boolean,
    adminNotes: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    notes: '',
  }),
  computed: {
    show: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  mounted() {
    this.notes = this.adminNotes
  },
}
</script>
